import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, OnInit, ViewChild } from '@angular/core';
import { Component } from '@angular/core';
import { FullCalendarComponent } from '@fullcalendar/angular';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import { Calendar, CalendarOptions, EventClickArg, EventContentArg, EventDropArg, EventSourceInput } from '@fullcalendar/core';
import { BreadDik, EventsModel, QueovalParam, UpdateDate, QueovalDateTime, Result } from 'projects/lib-components/src/models';
import { ConflitsReservations, EtatPresence, PlanningOnglet, ReservationPlanning } from 'projects/lib-components/src/models/formation/planning.model';

import { CoreService, HttpService, QueovalDateService } from 'projects/lib-components/src/services';
import { PlanningService } from '../planning.service';
import { StageService } from '../../services/stage-modal.service';

@Component({
  selector: 'q-planning-calendrier',
  templateUrl: './calendrier.component.html',
  styleUrls: ['./calendrier.component.css'],
})

export class CalendrierComponent implements OnInit {

  public fullCalendar: FullCalendarComponent;
  @ViewChild('calendar') set SetFullCalendar(value: FullCalendarComponent) {
    this.fullCalendar = value;
    this.cd.detectChanges();
  }

  public calendar: Calendar;
  /** liste des mois de l'année au format long (janvier, février,...) dans la culture de l'utilisateur connecté*/
  public months: Array<string> = [];
  /** mois sélectionné */
  public month: string;
  /** année sélectionnés */
  public year: number;
  /** date du jour*/
  public today: Date = new Date(Date.now());

  public calendarOptions: CalendarOptions = { plugins: [dayGridPlugin, interactionPlugin] };
  
  constructor(
    private indParam: CoreService,
    private http: HttpService,
    private cd: ChangeDetectorRef,
    public planningService: PlanningService,
    public qDateService: QueovalDateService,
    public stageService: StageService,
  ) {
    planningService.filter$.subscribe(() => {
      if (this.planningService.filterLoaded) {
        this.calendarOptions = this.UpdateOption(this.OnSelectRange);
      }
    })
  }

  ngOnInit(): void {
    //#region créer la liste des mois au format long dans la culture de l'utilisateur connecté
    var format = new Intl.DateTimeFormat(this.indParam.AppParams.culture, { month: 'long' });
    for (let month: number = 0; month < 12; month++) {
      var date = new Date(Date.UTC(2000, month, 1, 0, 0, 0));
      this.months.push(format.format(date))
    }
    //#endregion

    this.month = this.months[this.today.getMonth()];
    this.year = this.today.getFullYear();
  }

  /**
   * callback du FullCalendarComponent à la sélection de plage de dates affecte la date début et fin dans le planningService
   * @param this.planningService PlanningService du planning en cours car innaccessible depuis le callback
   * @param fullCalendar FullCalendarComponent du planning en cours car innaccessible depuis le callback
   * @param event evenement du callback avec les dates de début et de fin
   */
  public OnSelectRange(planningService: PlanningService, fullCalendar: FullCalendarComponent, event: any): void {
    //fullcalendar retourne le jour suivant la dernière date sélectionnée
    //ex plage du 8 au 16, retour, du 8 au 17
    //d'où le setDate -1 jour.
    (event.end as Date).setDate((event.end as Date).getDate() - 1);

    // possibilité de soit faire une sélection en gardant le clic enfoncé
    //soit en cliquant sur la date début ; puis en cliquant sur la date de fin tout en maintenant Alt

    //si la date début == date fin => clic simple sur une date
    //si clic simple + Alt enfoncé
    if (event && event.jsEvent && event.jsEvent.altKey && event.start.getTime() == event.end.getTime()) {
      //#region définition de la plage de date en fonction de la date précédemment sélectionnée.
      let calendar: Calendar = fullCalendar.getApi();
      //récupération de la date de début par rapport au planningService
      let dateDebut: Date | null = this.qDateService.ToDate(this.planningService.DateDebut);
      //si date cliquée après date début
      //=> trigger OnSelectRange() avec event.start = date cliquée et event.end = date début du planning service
      if (dateDebut != null && event.start.getTime() > dateDebut.getTime()) {
        (event.start as Date).setDate((event.start as Date).getDate() + 1);
        calendar.select(dateDebut, event.start);
      }
      //sinon trigger OnSelectRange() avec event.start = date début du planning service et event.end = date cliquée
      else {
        if (dateDebut != null) {
          //setdate +1 jour pour que la dateDébut ne soit pas exclue de la plage.
          dateDebut.setDate(dateDebut.getDate() + 1);
          calendar.select(event.start, dateDebut);
        } else {
          //si la date de début n'existe pas sur le planning service
          // trigger OnSelectRange() avec date debut == date fin mais Alt non enfoncé.
          calendar.select(event.start, event.start);
        }
      }
      //utilisation du calendar.select plutot que d'affecter directement les dates du planning service
      //afin que les cases se colorent dans le calendrier (simulation d'une sélection de plage par l'utilisateur)
      return;
      //#endregion
    }

    this.planningService.DateDebut = this.qDateService.FromDateTime(event.start);
    this.planningService.DateFin = this.qDateService.FromDateTime(event.end);

  }

  /** calcul les indexes du mois et au besoin de l'année avant d'appeler OnMonthChange() */
  public NextMonth(): void {
    let index: number = this.months.findIndex(m => m == this.month) + 1;
    if (index > 11) {
      index = 0;
      this.year++;
    }
    this.month = this.months[index];
    this.OnMonthChange();
  }

  /** calcul les indexes du mois et au besoin de l'année avant d'appeler OnMonthChange() */
  public PreviousMonth(): void {
    let index: number = this.months.findIndex(m => m == this.month) - 1;
    if (index < 0) {
      index = 11;
      this.year--;
    }
    this.month = this.months[index];
    this.OnMonthChange();
  }

  /** calcul la date à passer au FullCalendarComponent à partir du mois et de l'année sélectionnée */
  public OnMonthChange() {
    // date au 1er du mois sélectionné à l'année sélectionnée
    const date: Date = new Date(this.year, this.months.findIndex(m => m == this.month), 1);

    if (this.fullCalendar)
      this.calendar = this.fullCalendar.getApi();
    this.calendar.gotoDate(date);
  }

  /**
   * appelé au (change) de l'input date, 
   * @param year doit être suppérieure à 1000 pour que la date du calendrier soit mise à jour
   */
  public OnYearChange(year: number): void {
    if (year > 1000) {
      const date: Date = new Date(year, this.months.findIndex(m => m == this.month), 1);
      if (this.fullCalendar)
        this.calendar = this.fullCalendar.getApi();
      this.calendar.gotoDate(date);
    }
  }

  /**
   * permet de changer le mode d'affichage du planning
   * @param view https://fullcalendar.io/docs/Calendar-changeView
   */
  public OnViewChange(view: string): void {
    (this.fullCalendar as any).calendar.changeView(view);
  }


  private UpdateOption(callbackSelectCliecked: any): CalendarOptions {
    //les paramètre dateDebut, dateFin, formateurs, showOnlyNew et pView ne sont pas utilisés à proprement parlé dans l'algorythme
    // s'il sont passés en paramètre, c'est simplement pour pouvoir écouter leurs changements et et rappeler le pipe le cas échéant.
    const datePipe: DatePipe = new DatePipe(this.indParam.AppParams.culture);
    const list: Array<ReservationPlanning> = JSON.parse(JSON.stringify(this.planningService.ListeReservationsFilter.filter(reserv => {
      return (this.planningService?.View == PlanningOnglet.Planning || (this.planningService?.View == PlanningOnglet.SuiviPresence && reserv.Ident && reserv.Ident != '0')) && reserv;
    })));
    //cf documentation: https://fullcalendar.io/docs#toc
    const result: CalendarOptions = {
      //si true affiche tout le temps 6 lignes, sinon affiche entre 4 et 6 lignes suivant le mois (https://fullcalendar.io/docs/fixedWeekCount)
      fixedWeekCount: false,
      //Sunday=0, Monday=1, Tuesday=2, etc (https://fullcalendar.io/docs/firstDay)
      firstDay: this.indParam.AppParams.culture.toLocaleLowerCase() == "fr-fr" ? 1 : 0,
      //https://fullcalendar.io/docs/initialView
      initialView: 'dayGridMonth',
      locale: this.indParam.AppParams.culture,
      height: 'auto',

      selectable: true,

      editable: true,
      droppable: true,
      eventResizableFromStart: true,
      eventDisplay: 'block',
      select: callbackSelectCliecked.bind(this, this.planningService, this.fullCalendar),
      headerToolbar: false,
      eventDrop: (e: EventDropArg) => {
        const start: Date | null = e.event.start;
        const end: Date | null = e.event.end;
        if (start == null || start == undefined || end == null || end == undefined) {
          return;
        }
        const startMonth: string = start?.getMonth() + 1 > 10 ? `${start?.getMonth() + 1}` : `0${start?.getMonth() + 1}`;
        const startDay: string = start?.getDate() > 10 ? `${start?.getDate()}` : `0${start?.getDate()}`;
        const startHours: string = (e.event.extendedProps as ReservationPlanning).DateDebut.heures;
        const startMinutes: string = (e.event.extendedProps as ReservationPlanning).DateDebut.minutes;
        const qDateDebut: QueovalDateTime = new QueovalDateTime(start?.getFullYear().toString(), startMonth, startDay, startHours, startMinutes);

        const endMonth: string = end?.getMonth() + 1 > 10 ? `${end?.getMonth() + 1}` : `0${end?.getMonth() + 1}`;
        const endDay: string = end?.getDate() > 10 ? `${end?.getDate()}` : `0${end?.getDate()}`;
        const endHours: string = (e.event.extendedProps as ReservationPlanning).DateDebut.heures;
        const endMinutes: string = (e.event.extendedProps as ReservationPlanning).DateDebut.minutes;
        const qDateFin: QueovalDateTime = new QueovalDateTime(end?.getFullYear().toString(), endMonth, endDay, endHours, endMinutes);

        const update: EventsModel = new EventsModel();
        update.UpdateDate = new UpdateDate();
        update.UpdateDate.idFils = (e.event.extendedProps as ReservationPlanning).Ident;
        if (!update.UpdateDate.idFils || update.UpdateDate.idFils == "0") {

          // si c'est une résa issue du découpage ; true si date début, date de fin trouvées et ident == 0
          const i = this.planningService.ListeReservations.findIndex(resa => (
            this.qDateService.Compare((e.oldEvent.extendedProps as ReservationPlanning).DateDebut, '=', resa.DateDebut)
            && (e.oldEvent.extendedProps as ReservationPlanning).DateDebut.heures == resa.DateDebut.heures
            && (e.oldEvent.extendedProps as ReservationPlanning).DateDebut.minutes == resa.DateDebut.minutes

            && this.qDateService.Compare((e.oldEvent.extendedProps as ReservationPlanning).DateFin, '=', resa.DateFin)
            && (e.oldEvent.extendedProps as ReservationPlanning).DateFin.heures == resa.DateFin.heures
            && (e.oldEvent.extendedProps as ReservationPlanning).DateFin.minutes == resa.DateFin.minutes
          ));

        
          if (i > -1) {
            this.planningService.ListeReservations[i].DateDebut = qDateDebut;
            this.planningService.ListeReservations[i].DateFin = qDateFin;
            const reserv: ReservationPlanning = this.planningService.ListeReservations[i];
            this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/Stage/${reserv.Ident}/Planning/UPDATE_RESERV`, reserv).subscribe((response: Result<ReservationPlanning>) => {
              this.planningService.ListeReservations[i] = response.Value;

              if (this.qDateService.Compare(this.planningService.Filter.DateDebut, '>', reserv.DateDebut)) {
                this.planningService.Filter.DateDebut = reserv.DateDebut;
              }
              if (this.qDateService.Compare(this.planningService.Filter.DateFin, '<', reserv.DateDebut)) {
                this.planningService.Filter.DateFin = reserv.DateDebut;
              }
              this.planningService.OnRefreshDisplay(false);
            });
          }        
        }
        else {
          update.UpdateDate.dateDebut = qDateDebut;
          update.Mode = 'UPDATE_DATE';
          this.http.postHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events`, update).subscribe(() => {
            const i = this.planningService.ListeReservations.findIndex(r => r.Ident == update.UpdateDate.idFils);
            if (i > -1) {
              this.http.getHttp<Result<ReservationPlanning>>(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/GET_RESERV/${update.UpdateDate.idFils}`).subscribe((resa: Result<ReservationPlanning>) => {
                console.log(resa.Value);
                this.planningService.SetReservation(resa.Value.Ident, resa.Value);
                if (this.qDateService.Compare(this.planningService.Filter.DateDebut, '>', resa.Value.DateDebut)) {
                  this.planningService.Filter.DateDebut = resa.Value.DateDebut;
                }
                if (this.qDateService.Compare(this.planningService.Filter.DateFin, '<', resa.Value.DateDebut)) {
                  this.planningService.Filter.DateFin = resa.Value.DateDebut;
                }
                this.planningService.ListeReservations.forEach(r => {
                  r.Conflits = r.Conflits.filter(c => c.IdentResa != update.UpdateDate.idFils);
                  if (resa.Value.Conflits.map(c => c.IdentResa).includes(r.Ident)) {
                    const conflit: ConflitsReservations = new ConflitsReservations();
                    conflit.IdentResa = resa.Value.Ident;
                    conflit.DateDebutResa = resa.Value.DateDebut;
                    conflit.DateFinResa = resa.Value.DateFin;
                    conflit.NomItem = resa.Value.Titre;
                    conflit.NomResa = this.stageService.Stage.Titre;
                    r.Conflits.push(conflit);
                  }
                });
                this.planningService.OnRefreshDisplay(false);
              });
            }
          });
        }
      },
      eventClick: (info: EventClickArg): void => {
        this.planningService.ListeReservationsFilter.forEach(resa => {
          let isEdit = false;
          if (resa.Ident == (info.event.extendedProps as ReservationPlanning).Ident) {
            //si c'est une résa existante édition ; true si ident trouvé
            if ((info.event.extendedProps as ReservationPlanning).Ident != '' && (info.event.extendedProps as ReservationPlanning).Ident != '0') {
              this.planningService.idReserv = resa.Ident;
              isEdit = true;
            }
            // si c'est une résa issue du découpage ; true si date début, date de fin trouvées et ident == 0
            else if (
              this.qDateService.Compare((info.event.extendedProps as ReservationPlanning).DateDebut, '=', resa.DateDebut)
              && (info.event.extendedProps as ReservationPlanning).DateDebut.heures == resa.DateDebut.heures
              && (info.event.extendedProps as ReservationPlanning).DateDebut.minutes == resa.DateDebut.minutes

              && this.qDateService.Compare((info.event.extendedProps as ReservationPlanning).DateFin, '=', resa.DateFin)
              && (info.event.extendedProps as ReservationPlanning).DateFin.heures == resa.DateFin.heures
              && (info.event.extendedProps as ReservationPlanning).DateFin.minutes == resa.DateFin.minutes
            ) {
              this.planningService.idReserv = resa.Ident;
              this.planningService.boParam = new QueovalParam();
              this.planningService.boParam.params = [new BreadDik('isLoaded', true)];
              this.planningService.boParam.model = resa.BoReserv;
              isEdit = true;
            }
          }
          resa.IsEdit = isEdit;
        });
        this.planningService.ViewChange.next(this.planningService.View);
      },
      eventContent: (arg: EventContentArg) => {
        let div: HTMLDivElement = document.createElement('div');
        div.style.overflow = 'hidden';
        div.style.textOverflow = 'ellipsis';
        div.style.fontSize = '10px';
        if ((arg.event.extendedProps as ReservationPlanning).TypeReserv == "Intervalle") {
          div.innerHTML = `${datePipe.transform(this.qDateService.ToString((arg.event.extendedProps as ReservationPlanning).DateDebut, 'yyyy-MM-dd hh:mm'), 'short')} - ${datePipe.transform(this.qDateService.ToString((arg.event.extendedProps as ReservationPlanning).DateFin, 'yyyy-MM-dd hh:mm'), 'short')}`;
          div.title = `${datePipe.transform(this.qDateService.ToString((arg.event.extendedProps as ReservationPlanning).DateDebut, 'yyyy-MM-dd hh:mm'), 'short')} - ${datePipe.transform(this.qDateService.ToString((arg.event.extendedProps as ReservationPlanning).DateFin, 'yyyy-MM-dd hh:mm'), 'short')}  ${(arg.event.extendedProps as ReservationPlanning).Titre}`;
        } else {
          div.innerHTML = `${(arg.event.extendedProps as ReservationPlanning).DateDebut.heures}:${(arg.event.extendedProps as ReservationPlanning).DateDebut.minutes} - ${(arg.event.extendedProps as ReservationPlanning).DateFin.heures}:${(arg.event.extendedProps as ReservationPlanning).DateFin.minutes}`;
          div.title = `${(arg.event.extendedProps as ReservationPlanning).DateDebut.heures}:${(arg.event.extendedProps as ReservationPlanning).DateDebut.minutes} - ${(arg.event.extendedProps as ReservationPlanning).DateFin.heures}:${(arg.event.extendedProps as ReservationPlanning).DateFin.minutes}  ${(arg.event.extendedProps as ReservationPlanning).Titre}`;
        }
        if (this.planningService.View != PlanningOnglet.SuiviPresence && (arg.event.extendedProps as ReservationPlanning).Conflits?.length > 0) {
          let warning: HTMLElement = document.createElement('i');
          warning.classList.add(...["fas", "fa-xs", "fa-exclamation", "position-absolute"]);
          warning.style.left = '-3px';
          warning.style.color = 'white';
          warning.style.top = '-3px';
          warning.style.backgroundColor = 'var(--c-danger)';
          warning.style.width = '10px';
          warning.style.height = '10px';
          warning.style.justifyContent = 'center';
          warning.style.borderRadius = '50%';
          warning.style.alignItems = 'center';
          warning.style.display = 'flex';
          div.appendChild(warning);
        }
        let arrayOfDomNodes = [div];
        return { domNodes: arrayOfDomNodes };
      }
    };
    const events: EventSourceInput = [];
    list.forEach(resa => {
      if (this.planningService.View != PlanningOnglet.SuiviPresence || (resa.Ident && resa.Ident != '0')) {
        events.push({
          extendedProps: resa,
          start: (this.qDateService.ToDateTime(resa.DateDebut) as Date),
          end: (this.qDateService.ToDateTime(resa.DateFin) as Date),
          allDay: false,
          title: resa.Titre,
          interactive: true,
          className: this.planningService.View == PlanningOnglet.SuiviPresence ? (resa.Etat == EtatPresence.OK ? 'q-success' : resa.Etat == EtatPresence.PARTIAL ? 'q-warning' : resa.Etat == EtatPresence.NONE ? 'q-danger' : 'q-secondary') : (!resa.Ident || resa.Ident == '0' ? 'q-warning' : 'q-secondary')
        });
      }
    })
    result.events = events;
    return result;
  }
}
